import React from 'react';
import PropTypes from 'prop-types';
import { Row, Alert } from 'reactstrap';
import AddCard from '../../Assets/components/AddCard';
import LoadingCard from '../../Assets/components/LoadingCard';
import AssetCard from '../../Assets/components/AssetCard';
import { getListAssetsFromCompany } from '../../../utils/functions';

const Patrimoine = ({
  assetId, assets, openAsset, openModalAdd, isAdding, isViewOnly, list_assets,
}) => {
  const listAssets = getListAssetsFromCompany(isViewOnly ? list_assets : assets, assetId);
  return (
    <div>
      {
        !isViewOnly && (
          <Alert color="info">
            Renseignez ici tous les biens ou investissements de votre entreprise.
          </Alert>
        )
      }
      <Row>
        {!isViewOnly && <AddCard mainCategory="all" openModalAdd={openModalAdd} />}
        {isAdding && <LoadingCard />}
        {
          listAssets.map(asset => (
            <AssetCard openAsset={openAsset} key={asset._id} data={asset} />
          ))
        }
        {
          isViewOnly && listAssets.length === 0 && (
            <div>
              Aucun bien renseigné.
            </div>
          )
        }
      </Row>
    </div>
  );
};

Patrimoine.propTypes = {
  assetId: PropTypes.string.isRequired,
  isAdding: PropTypes.bool,
  assets: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  openAsset: PropTypes.func.isRequired,
  openModalAdd: PropTypes.func,
  isViewOnly: PropTypes.bool.isRequired,
  list_assets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Patrimoine.defaultProps = {
  isAdding: false,
  openModalAdd: () => {},
};

export default Patrimoine;
